import React, { FC } from 'react';
import { STATE_OPTIONS, VALID_US_STATES_TYPE } from 'Shared/constants/states';
import { StateAsset, isStateAssetVariant } from 'Shared/components';
import styles from './styles.module.css';

export const StateWithLabel: FC<{ state: VALID_US_STATES_TYPE }> = ({
  state,
}) => {
  return (
    <div className={styles.state}>
      <div className={styles.map}>
        {isStateAssetVariant(state) && (
          <StateAsset
            stateVariant={state}
            width={32}
            height={32}
            description={state}
            className={styles.stateIcon}
          />
        )}
      </div>
      <div className={styles.title}>{STATE_OPTIONS[state]}</div>
    </div>
  );
};
